// extracted by mini-css-extract-plugin
module.exports = {"container":"termites-module--container--3afJp","species":"termites-module--species--2NMLR","speciesTitle":"termites-module--species-title--3p9kK"};